import { TextTwoColumn } from '@boels/models';
import { CmsComponentData } from '@boels/models';
import { of } from 'rxjs';

export const mockTextTwoColumn: TextTwoColumn = {
  leftContent:
    '<h1>2 column title/text Editor</h1><div><a href="product">products paragraph router link</a></div>',
  rightContent:
    '<p>Sed quae blanditiis sit iusto recusandae ut velit cumque qui neque porro. Et dolorum galisum cum consequatur quis aut reprehenderit perspiciatis. Quo consequuntur enim in aperiam eveniet in adipisci voluptatem eum dolorum tempore At magnam tempore 33 voluptas dolor.</p><p>Sit quia dolor ut dolore similique aut natus sint et mollitia natus. Sit impedit distinctio aut debitis galisum in neque odio et beatae necessitatibus cum reprehenderit molestiae aut voluptatem consequatur rem suscipit quasi.</p>',
  removeBottomSpacing: true,
};

export const mockTextTwoColumnRight: TextTwoColumn = {
  leftContent:
    '<p>Sed quae blanditiis sit iusto recusandae ut velit cumque qui neque porro. Et dolorum galisum cum consequatur quis aut reprehenderit perspiciatis. Quo consequuntur enim in aperiam eveniet in adipisci voluptatem eum dolorum tempore At magnam tempore 33 voluptas dolor.</p><p>Sit quia dolor ut dolore similique aut natus sint et mollitia natus. Sit impedit distinctio aut debitis galisum in neque odio et beatae necessitatibus cum reprehenderit molestiae aut voluptatem consequatur rem suscipit quasi.</p>',
  rightContent:
    '<h1>2 column title/text Editor</h1><div><a href="product">products paragraph router link</a></div>',
  removeBottomSpacing: true,
};

export const mockTextTwoColumnComponentData: CmsComponentData<TextTwoColumn> = {
  data$: of(mockTextTwoColumn),
};

export const mockTextTwoColumnComponentDataRight: CmsComponentData<TextTwoColumn> =
  {
    data$: of(mockTextTwoColumnRight),
  };
